import { Component, Input, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { SlideDTO } from '@app/model/slideDTO.model';
import { SettingsService } from '@app/services/settings.service';

@Component({
    selector: 'app-slide-social-wall',
    templateUrl: './slide-social-wall.component.html',
    standalone: false
})
export class SlideSocialWallComponent {
  @Input() public data: SlideDTO;

  private readonly router = inject(Router);
  private readonly settingsService = inject(SettingsService);

  public defaultChannelId = toSignal(
    this.settingsService.getSettings().pipe(map(settings => settings.social_wall?.default_public_wall_id ?? null))
  );

  public navigateToSocialWall(): void {
    const channelId = this.data.social_wall?.items?.[0]?.id;

    this.router.navigate(['/social-wall'], {
      queryParams: channelId ? { channel: channelId } : undefined
    });
  }
}
